<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <div class="d-flex justify-center mb-4">
          <p class="h1 h1--bold">CLAÚSULAS</p>
        </div>
        <ol>
          <!-- punto 1 -->
          <li class="body-2 justify-text">
            <b>Duración:</b>
            <ol>
              <li class="body-2 justify-text">
                El presente Acuerdo tendrá una vigencia inicial de UN AÑO a contar desde la fecha de
                formalización del mismo. Llegada la fecha de su vencimiento, el mismo se renovará
                automáticamente por iguales periodos de tiempo salvo que cualquiera de las partes
                hubiese comunicado a la contraparte con anterioridad a la fecha de terminación, su
                intención de darlo por finalizado a su vencimiento inicial o de cualquiera de sus
                prórrogas. Sin perjuicio de lo anterior, ambas partes podrán resolver
                anticipadamente el presente contrato en cualquier momento y sin necesidad de alegar
                causa alguna, bastando para ello con una comunicación por escrito a la contraparte
                con un preaviso mínimo de quince días sobre la fecha de resolución prevista.
              </li>
            </ol>
          </li>
          <!-- punto 2 -->
          <li class="body-2 justify-text">
            <b>Objeto y condiciones de prestación del contrato</b>
            <ol>
              <li class="body-2 justify-text">
                El presente Acuerdo recoge las condiciones que regirán las relaciones entre las
                partes derivadas de la prestación por parte de CTT EXPRESSO-SERVIÇOS POSTAIS E
                LOGISTICA S.A. SUCURSAL EN ESPAÑA, (en adelante CTT EXPRESSO) al CLIENTE de los
                servicios de transporte continuado, logística y actividades relacionadas, tanto en
                ámbito nacional como internacional, todo ello a cambio del precio acordado en las
                Tarifas adjuntas o en aquellas que las sustituyan durante la vigencia del contrato.
              </li>
              <li class="body-2 justify-text">
                EL CLIENTE se obliga a preparar debidamente todos los envíos, sobres, paquetes o
                valijas, los cuales deberán estar precintados y cerrados de forma segura, y
                perfectamente etiquetados para su debida identificación (indicando si es frágil o
                presenta alguna otra particularidad) y/o cualquier otra característica necesaria
                para la identificación del servicio; siempre teniendo en cuenta el contenido de la
                estipulación Cuarta siguiente, en lo que a envíos especiales se refiere.
              </li>
              <li class="body-2 justify-text">
                Queda prohibida la entrega de paquetes u objetos cuyo contenido sea contrario a la ley, moral o buenas
                costumbres, o de tráfico ilícito, quedando CTT EXPRESSO exonerada de cualquier responsabilidad que
                pudiera derivarse del transporte de paquetes, de los antes referidos. CTT EXPRESSO se reserva el derecho
                de dar parte a las Autoridades Competentes para que procedan a examinar el envío en los supuestos que
                así lo considere oportuno.
              </li>
              <li class="body-2 justify-text">
                CTT EXPRESSO se reserva el derecho a no prestar un servicio determinado cuando le
                parezca anómalo el contenido del paquete o las circunstancias que rodean a un
                determinado servicio, así como cuando existan dudas razonables acerca del contenido
                de un paquete o embalaje determinado y EL CLIENTE se niegue infundadamente a
                consentir la comprobación del mismo por parte de CTT EXPRESSO con carácter previo a
                su recogida y posterior envío.
              </li>
              <li class="body-2 justify-text">
                No se admiten animales vivos, líquidos corrosivos o nocivos, gases y aerosoles
                inflamables y materias explosivas o inflamables, de acuerdo a la normativa ADR,
                mercancías perecederas, envíos en metálico, joyas y obras de arte.
              </li>
              <li class="body-2 justify-text">
                El precio de los envíos se determina de acuerdo a su peso real o volumétrico,
                aplicándose el mayor de los dos. CTT EXPRESSO podrá, aleatoriamente, pesar y medir
                cualquier envío del Cliente, con el objeto de comprobar la corrección de los datos
                consignados por el CLIENTE en el albarán. Si de la comprobación realizada se
                acreditase que los datos consignados por el Cliente no se corresponden con el peso y
                las medidas reales del envío, CTT EXPRESSO procederá a modificarlo en el sistema y
                el albarán y lo facturará en base a los datos reales, renunciando el Cliente a
                efectuar reclamación alguna por dicho motivo, ni a solicitar la rectificación,
                compensación o abonos sobre las facturas emitidas recogiendo la diferencia de pesaje
                facturado.
              </li>
              <li class="body-2 justify-text">
                Si el Remitente no consignara el peso en la Carta de Porte/Albarán o a través de los
                sistemas automatizados, y no se pudiera obtener ese dato a través de los equipos de
                pesaje de CTT EXPRESSO por la causa que fuese, se considerará un peso mínimo de 3
                Kg. a efectos de facturación, renunciando el Cliente efectuar reclamación alguna de
                rectificación, compensación o abonos sobre facturas, motivadas por esta
                circunstancia. La reiteración en el error en el manifiesto de pesos y medidas por
                parte del cliente facultará a CTT EXPRESSO para proceder a la resolución unilateral
                sin necesidad de preaviso.
              </li>
              <li class="body-2 justify-text">
                En caso de que CTT EXPRESSO tuviera que reetiquetar el envío por falta de calidad en
                la etiqueta para su correcta lectura, se aplicará un cargo de 0,20<span class="euro-symbol">€</span>
                por etiqueta.
              </li>
              <li class="body-2 justify-text">
                Las partes aceptan expresamente que las copias de las Cartas de Porte o albaranes
                emitidos electrónicamente tienen pleno valor probatorio a todos los efectos,
                incluidos los judiciales o en sede arbitral.
              </li>
              <li class="body-2 justify-text">
                EL CLIENTE no podrá ofrecer servicios de transporte a terceros actuando como
                intermediario entre sus propios Clientes y CTT EXPRESSO.
              </li>
              <li class="body-2 justify-text" data-cy="deliveryEffectiveness">
                Con el objetivo de garantizar la efectividad de la entrega de los envíos emitidos
                por el CLIENTE, CTT EXPRESSO <u>ha habilitado diferentes canales de comunicación con
                  los destinatarios</u>, con el objetivo de que estos puedan para acomodar las entregas
                en función de sus preferencias y circunstancias particulares. <u>Las notificaciones
                  que se remiten por defecto a los destinatarios que hayan facilitado su email</u>,
                incluyen un enlace que les permitirá registrar cambios en las instrucciones de
                entrega (dirección, punto de cercanía y/o día de entrega). El CLIENTE es conocedor
                y acepta que las variaciones solicitadas por el destinatario pueden modificar el
                compromiso del servicio y que ello no supone incumplimiento por parte de CTT
                EXPRESSO. En el supuesto de que el CLIENTE no esté de acuerdo en la aplicación de
                esta operativa y no desee que alguno o todos de sus destinatarios pueda modificar
                las instrucciones de entrega, deberá contactar con CTT EXPRESSO a través de su
                comercial asignado para informar de ello y restringir la posibilidad de que el
                destinatario pueda realizar los cambios indicados. Salvo indicación expresa por
                escrito, se entenderá que el CLIENTE está de acuerdo con el procedimiento indicado.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 1" />
    </div>
    <!-- Página contrato 2-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <ol class="third-ol">
          <!-- punto 3 -->
          <!-- punto 3 -->
          <li class="body-2 justify-text">
            <b>Condiciones económicas: Precios y revisión.</b>
            <ol>
              <li class="body-2 justify-text">
                El precio de los servicios que son objeto de este contrato son los recogidos en las
                tarifas anexas, los cuales se verán incrementado con el Impuesto sobre el Valor
                Añadido (IVA) vigente en cada momento y/o cualquier impuesto otro que pudiera
                resultar aplicable.
              </li>
              <li class="body-2 justify-text">
                Además de su aplicación al Cliente, las Tarifas serán aplicadas en todos los centros
                que el Cliente tuviese en España, siempre y cuando previamente este así lo haya
                solicitado y haya sido aprobado por CTT EXPRESO. Si el Cliente solicitara algún
                servicio que no estuviese incluido en las Tarifas adjuntas, se aplicará el precio
                establecido en las tarifas generales que CTT EXPRESSO tuviese vigentes en ese
                momento. En el supuesto de que por error o falta de información del Cliente no
                hubiese indicado el tipo de servicio, se prestará el más urgente y se cobrará el
                establecido para este.
              </li>
              <li class="body-2 justify-text">
                Los precios convenidos para la prestación del servicio permanecerán en vigor hasta
                el 31 de diciembre del año que se firme el Contrato, salvo en aquellos contratos
                suscritos entre el 01 de septiembre y el 31 de diciembre, en cuyo caso se mantendrán
                vigentes hasta el 31 de diciembre del siguiente año. Previamente a la fecha indicada
                los precios serán revisados antes del vencimiento del contrato.
              </li>
              <li class="body-2 justify-text">
                Igualmente, CTT EXPRESSO se reserva el derecho de modificar en cualquier momento
                durante la vigencia del contrato, las tarifas adjuntas por causas logísticas,
                operativas o de necesidad para la Red.
              </li>
              <li class="body-2 justify-text">
                La revisión de precios indicada en los puntos 3.3. y 3.4. será comunicada al Cliente
                con antelación a su fecha de aplicación. Dicha comunicación se efectuará por escrito
                a través de su correo electrónico o incluyéndolo en su área de Cliente de la Web. El
                Cliente dispondrá de un plazo de siete (7) días naturales a contar desde la
                comunicación para mostrar su no aceptación. En el supuesto de que el Cliente no
                comunique su disconformidad a los nuevos precios aplicables, se entenderá otorgada
                su conformidad a los mismos, renunciando a efectuar reclamación alguna por dicho
                motivo, ni a solicitar la rectificación, compensación o abonos sobre las facturas
                emitidas con las nuevas tarifas.
              </li>
              <li class="body-2 justify-text">
                En el supuesto de que el Cliente manifieste en plazo su disconformidad con la nueva
                propuesta de precios, CTT EXPRESSO podrá resolver el presente Acuerdo a su
                vencimiento, sin necesidad de cumplir el preaviso de quince días señalado en la
                cláusula 1ª.
              </li>
              <li class="body-2 justify-text">
                Será de aplicación el art. 38 de la
                <em>Ley 15/2009 del Contrato de Transporte Terrestre de Mercancías (CTTM), "Revisión
                  de precios del transporte por carretera en función de la variación de precios del
                  gasóleo"</em>, el cual se aplicará de acuerdo a lo dispuesto en el citado artículo. Los
                incrementos por el “Suplemento de combustible” así como las bonificaciones que
                pudieran acordarse entre las partes, serán las recogidas en las propias tarifas.
              </li>
              <li class="body-2 justify-text">
                Los precios especiales que se aplicarán al Cliente han sido acordados por las partes
                en previsión de que el Cliente alcance el número de envíos mensuales recogido en el
                Acuerdo de Prestación de Servicios (APS) de esta oferta, en el apartado Puntos de
                Recogida Habitual, y al cual queda comprometido. Si el Cliente no alcanzase durante
                dos meses consecutivos el volumen de envíos acordado, CTT EXPRESSO adaptará
                automáticamente su tarifa al volumen real de envíos realizados en base a los precios
                generales establecidos para la Red y que podrá consultar en su área de Cliente de la
                web www.cttexpress.com.
              </li>
              <li class="body-2 justify-text">
                Adeudos o costes adicionales: Si CTT EXPRESSO tuviese que grabar de forma manual los
                datos para los envíos del Cliente (envíos no manifestados) debido a que el Cliente
                no generase su envío a través de su webservice o por cualquier otro motivo no
                imputable a CTT EXPRESSO, éste aplicará un cargo de acuerdo a la tarifa vigente en
                cada uno de los servicios afectados, en concepto de gastos de gestión y tratamiento,
                lo que se recogerá en la factura correspondiente a los envíos afectados.
              </li>
              <li class="body-2 justify-text">
                Aquellas recogidas encargadas por el Cliente que no puedan ser efectuadas por
                motivos imputables al mismo, tendrán un coste aplicable de acuerdo a la tarifa
                vigente. Se entenderán como tales motivos, entre otros, los siguientes: 1) Que en la
                dirección de recogida señalada no tenga mercancía para recoger o no esté preparada
                2) que la dirección facilitada sea incorrecta o resulte incompleta, 3) que la
                persona designada para la recogida se encuentre ausente o no responda.
              </li>
              <li class="body-2 justify-text">
                En el caso de que exista contradicción entre lo dispuesto en las Tarifas y lo
                recogido en este contrato, prevalecerá este último.
              </li>
            </ol>
          </li>
          <!-- punto 4 -->
          <li class="body-2 mt-6">
            <b>Facturación y pago:</b>
            <ol>
              <li class="body-2 justify-text">
                EL Cliente se obliga a abonar puntualmente los servicios prestados por CTT EXPRESSO.
                A tales efectos, este emitirá facturas mensuales que comprenderán todos los
                servicios prestados durante la mensualidad objeto de facturación, según las
                condiciones establecidas en el presente Acuerdo, con el desglose correspondiente,
                debiendo el Cliente proceder a su pago en el plazo acordado a contar desde su fecha
                de emisión.
              </li>
              <li class="body-2 justify-text">
                El Cliente podrá descargar las facturas a través de su Área de Cliente, en la Web
                <u>www.cttexpress.com.</u>
              </li>
              <li class="body-2 justify-text">
                El impago total o parcial de facturas por el Cliente desde el siguiente día natural
                a su vencimiento, facultará a CTT EXPRESSO para suspender temporalmente este
                acuerdo, pudiendo paralizar la mercancía del Cliente en las instalaciones de la Red,
                debiendo sufragar el Cliente la recogida y recepción de la mercancía paralizada. De
                mantenerse el impago, CTT EXPRESSO podrá proceder a la resolución del contrato,
                bastando con el simple aviso al Cliente sin necesidad de cumplir plazo de preaviso
                alguno. En esta situación de impago, el Cliente reconoce y acepta la facultad de CTT
                EXPRESSO para poder anticipar el vencimiento de las facturas pendientes de emisión
                así como las pendientes de pago, pudiendo exigir el pago inmediato de todas las
                cantidades pendientes, con aplicación de los intereses de demora y gastos
                ocasionados en la gestión del cobro.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 2" />
    </div>
    <!-- Página contrato 3-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <!-- punto 4 -->
        <ol class="fourth-ol">
          <li class="no-order body-2 mt-6">
            <ol class="fourth-ol">
              <li class="no-order body-2 justify-text">
                A las facturas vencidas y las anticipadamente vencidas que no hayan sido abonadas en
                el plazo correspondientes, se les aplicarán unos intereses de demora del 1% mensual
                desde la fecha en que fueran exigibles. Igualmente el Cliente deberá abonar los
                gastos generados por los tramites de cobro realizados, que se calcularán con un
                importe mínimo de 50<span class="euro-symbol">€</span>.
              </li>
              <li class="no-order body-2 justify-text">
                El Cliente se compromete a firmar la Orden Sepa para la domiciliación bancaria de
                los pagos.
              </li>
            </ol>
          </li>
        </ol>
        <ol class="fifth-ol">
          <!-- punto 5 -->
          <li class="body-2 justify-text">
            <b>Envíos Contrarrembolso:</b>
            <ol>
              <li class="body-2 justify-text">
                En los envíos emitidos por el Cliente con entrega contrarrembolso, CTT Expresso hará
                entrega al Cliente de las cantidades percibidas, en los plazos y condiciones
                recogidas en esta cláusula.
              </li>
              <li class="body-2 justify-text">
                El pago de los reembolsos se realizará de forma diaria mediante transferencia
                bancaria emitida a las 96 horas posteriores a la entrega del envío y/o envíos (salvo
                que resulte festivo o fin de semana, en cuyo caso se podrá adelantar o atrasar al
                día hábil correspondiente) y por tanto el cliente la recibirá en su cuenta bancaria
                el día posterior a su emisión es decir a las 120 horas.
              </li>
              <li class="body-2 justify-text">
                El abono de los reembolsos se hará efectivo en la cuenta corriente que el Cliente ha
                comunicado en la orden SEPA B2B que acompaña a este contrato (o en aquella que en el
                futuro designe).
              </li>
              <li class="body-2 justify-text">
                Coste financiero por transferencia con destino fuera del ámbito SEPA: Para todas aquellas transferencias
                de reembolso solicitadas por el cliente bajo cuentas bancarias (IBAN y SWIFT fuera del entorno SEPA), el
                cliente asumirá el coste adicional de las mismas en base a una tarifa adicional que cubre el coste
                financiero de la transferencia a razón de 0,45% sobre el importe transferido en concepto de coste
                financiero.
              </li>
              <li class="body-2 justify-text">
                En el caso de que el Cliente tenga algún impagado o deuda con CTT Expresso, se
                faculta a esta para que las cantidades señaladas en los puntos anteriores se
                destinen a compensar dicha deuda.
              </li>
            </ol>
          </li>
          <!-- punto 6 -->
          <li class="body-2 justify-text">
            <b>Responsabilidad de CTT EXPRESSO y cálculo de indemnizaciones:</b>
            <ol>
              <li class="body-2 justify-text">
                La prestación del servicio de transporte y mensajería se regirá por lo dispuesto en
                la
                <em>Ley 15/2009, de 11 de noviembre, del contrato de transporte terrestre de
                  mercancías</em>, (CTTM) a la que ambas partes se someten.
              </li>
              <li class="body-2 justify-text">
                La responsabilidad de CTT EXPRESSO por deterioro, perdida, o sustracción de la
                mercancía se regirá lo dispuesto por la Ley CTTM (o aquella que le sustituya), y en
                concreto por lo recogido en el Capítulo V. No se aceptará ninguna reclamación
                realizada por el Cliente fuera de los plazos previstos en la LCTTM o en los
                Convenios internaciones de aplicación, según corresponda, para efectuar la s
                reservas por escrito ni en el caso de que la tarifa del transporte no haya sido
                abonada previamente, sin que pueda el Cliente deducir la cantidad de su reclamación
                de la tarifa por el transporte.
              </li>
              <li class="body-2 justify-text">
                A los efectos de realizar el cálculo de las indemnizaciones, se tomará como base lo
                indicado en el art. 57 de la Ley CTTM.
              </li>
              <li class="body-2 justify-text">
                De acuerdo a lo indicado en el art. 57.2 CTTM, en caso de que CTT EXPRESSO entregase
                el envío con retraso respecto al Servicio solicitado por el Cliente, el precio a
                abonar será el correspondiente al realmente prestado, compensándose en favor del
                Cliente la diferencia de precio entre ambos servicios y siendo ésta la indemnización
                que por retraso corresponde al Cliente.
              </li>
              <li class="body-2 justify-text">
                Exoneración de responsabilidad: Sin perjuicio de otras causas de exoneración
                conforme a la legislación vigente, CTT EXPRESSO no responderá por las deficiencias o
                insuficiencias de embalaje, naturaleza o vicio propio de las mercancías, deficiente
                identificación o señalización de los bultos o, en general, como consecuencia del
                incumplimiento del Cliente o consignatario de sus obligaciones contractuales o
                legales.
              </li>
            </ol>
          </li>
          <!-- punto 7 -->
          <li class="body-2 justify-text">
            <b>Código de Cliente:</b>
            <ol>
              <li class="body-2 justify-text">
                Para la utilización de los servicios objeto de este acuerdo, CTT EXPRESSO facilitará
                al Cliente un código de Cliente personal e intransferible, que aparecerá reflejado
                en las Cartas de Porte o Albaranes, y que servirá para identificar aquellos
                servicios solicitados por el Cliente aunque este no conste como remitente o
                destinatario, y a cuyo pago se compromete. El Cliente será responsable de su
                correcta utilización y de la custodia y no divulgación del citado código a terceras
                personas.
              </li>
              <li class="body-2 justify-text">
                El Cliente deberá identificarse con dicho código cuando así se lo requieran desde
                CTT EXPRESSO en el supuesto de solicite la entrega o recogida en una dirección
                diferente a la reflejada en la Carta de Porte o Albarán.
              </li>
            </ol>
          </li>
          <!-- punto 8 -->
          <li class="body-2 justify-text">
            <b>Incumplimientos y facultad de resolver el Acuerdo:</b>
            <ol>
              <li class="body-2 justify-text">
                El presente contrato quedará resuelto de pleno derecho por las siguientes causas: 1)
                Por haber llegado el contrato a su vencimiento inicial o al de cualquiera de sus
                prorrogas y mediar denuncia en plazo de no renovación por cualquiera de las partes,
                2) De mutuo acuerdo, en cualquier momento y siempre recogido por escrito, 3) El
                cumplimiento defectuoso, o incumplimiento total o parcial por cualquier causa de
                alguna de las obligaciones de las partes que derivan del presente contrato, sin que
                haya sido subsanado en el plazo otorgado para ello, lo que facultara a la parte
                cumplidora para exigir la rescisión anticipada sin necesidad de preaviso, 4) Cuando
                una de las partes vea limitada judicial o administrativamente, su capacidad para
                poder gestionar su actividad o para poder administrar o disponer de sus bienes, 5)
                Por no alcanzar un acuerdo en relación a la actualización de los precios y tarifas,
                6) La reventa o cesión de los servicios de CTT EXPRESSO cualquiera que sea la causa
                y modo utilizados 7) El uso indebido o negligente por parte de Cliente del material
                suministrado por CTT EXPRESSO, 8) Cualquier otra que en derecho resulte de
                aplicación.
              </li>
              <li class="body-2 justify-text">
                Sin perjuicio de la facultad de resolución, la parte cumplidora podrá exigir la
                correspondiente indemnización por daños y perjuicios, así como los gastos generados.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 3" />
    </div>
    <!-- Página contrato 4-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <ol class="ninth-ol">
          <!-- punto 9 -->
          <li class="body-2 justify-text">
            <b>Protección de datos y acceso a datos de carácter personal:</b>
            <ol>
              <li class="body-2 justify-text">
                Según reconoce el Informe de la AEPD 0064/2020 las empresas de mensajería tienen en
                general la condición de Responsables del Tratamiento, obrando en calidad de
                corresponsables del tratamiento realizado en general y/o actuando en ocasiones en
                calidad de Encargados del Tratamiento.
                <br />
                De forma general, para el caso de corresponsabilidad se establece cuanto se recoge a
                continuación:
              </li>
            </ol>
            <ol class="second-ol">
              <li class="body-2 justify-text">
                Obligaciones de los corresponsables del tratamiento
                <br />
                Los corresponsables del tratamiento se obligan a:
                <ul class="list-style-none body-2 justify-text">
                  <li>
                    a) Garantizar por parte de los interesados ante cualquiera de los
                    corresponsables el ejercicio de los derechos de:
                    <ul class="list-style-none body-2 justify-text">
                      <li class="pl-4">- Acceso, rectificación, supresión y oposición.</li>
                      <li class="pl-4">- Limitación del tratamiento.</li>
                      <li class="pl-4">- Portabilidad de datos.</li>
                      <li class="pl-4">
                        - A no ser objeto de decisiones individualizadas (incluida la elaboración de
                        perfiles).
                      </li>
                    </ul>
                  </li>
                  <li>
                    b) Los corresponsables deben resolver dentro del plazo establecido las
                    solicitudes de ejercicio de derechos y comunicar a la otra parte la recepción de
                    la solicitud a fin de que puedan resolver conjuntamente dichas solicitudes.
                  </li>
                  <li>
                    c) Los corresponsables, en el momento de la recogida de los datos, deben
                    facilitar la información relativa a los tratamientos de datos que se van a
                    realizar, incluyendo la identidad de los diversos responsables del tratamiento.
                  </li>
                  <li> d) Los corresponsables notificarán al resto de responsables del tratamiento, sin
                    dilación indebida, y en cualquier caso antes del plazo máximo de 48 horas, y a
                    través de comunicación electrónica, las violaciones de la seguridad de los datos
                    personales a su cargo de las que tenga conocimiento, juntamente con toda la
                    información relevante para la documentación y comunicación de la incidencia. No
                    será necesaria la notificación cuando sea improbable que dicha violación de la
                    seguridad constituya un riesgo para los derechos y las libertades de las
                    personas físicas.
                  </li>
                  <li>
                    e) Corresponde al corresponsable del tratamiento que haya sufrido una violación
                    de seguridad de los datos personales comunicar dicha circunstancia en el menor
                    tiempo posible a los interesados, cuando sea probable que la violación suponga
                    un alto riesgo para los derechos y las libertades de las personas físicas. La
                    comunicación debe realizarse en un lenguaje claro y sencillo y deberá, como
                    mínimo:
                    <ul class="list-style-none body-2 justify-text">
                      <li class="pl-4">- Explicar la naturaleza de la violación de datos.</li>
                      <li class="pl-4">
                        - Indicar el nombre y los datos de contacto del delegado de protección de
                        datos o de otro punto de contacto en el que pueda obtenerse más información.
                      </li>
                      <li class="pl-4">
                        - Describir las posibles consecuencias de la violación de la seguridad de
                        los datos personales.
                      </li>
                      <li class="pl-4">
                        - Describir las medidas adoptadas o propuestas por el responsable del
                        tratamiento para poner remedio a la violación de la seguridad de los datos
                        personales, incluyendo, si procede, las medidas adoptadas para mitigar los
                        posibles efectos negativos.
                      </li>
                    </ul>
                  </li>
                  <li>
                    f) Realizar conjuntamente las evaluaciones de impacto relativas a la protección
                    de datos, cuando proceda.
                  </li>
                  <li>
                    g) Ambas partes se obligan a poner mutuamente a su disposición toda la
                    información necesaria para demostrar el cumplimiento de sus obligaciones, así
                    como para la realización de las auditorías o las inspecciones que realicen el
                    responsable u otro auditor autorizado por él.
                  </li>
                  <li>h) Implantar las medidas de seguridad necesarias.</li>
                  <li>
                    i) Designar un delegado de protección de datos si así lo exige la legislación
                    europea y nacional, y comunicar su identidad y datos de contacto al responsable.
                  </li>
                </ul>
              </li>
              <li>
                Duración y resolución del contrato: El presente contrato se considera accesorio a la
                condición de las partes de corresponsables del tratamiento, por lo que su duración y
                extinción queda supeditada a la existencia de dicha condición.
              </li>
              <li>
                Actuando CTT-EXPRESS en condición de Encargado de Tratamiento
                <br />
                El presente contrato regula el tratamiento de ficheros de carácter personal por
                parte del Cliente como Responsable del Tratamiento y por parte de CTT EXPRESSO como
                Encargado del Tratamiento a los efectos de proporcionar correctamente el servicio de
                mensajería y transporte objeto del contrato. El Encargado del Tratamiento se
                compromete a tratar con la diligencia debida, con arreglo a su mejor criterio y
                dedicación profesional y de conformidad a la finalidad autorizada dichos datos
                personales. El acceso a los mismos no es considerado comunicación de datos.
              </li>
              <li>
                Los datos del destinatario serán tratados únicamente para proceder a la entrega del
                servicio contratado tratándose los siguientes datos personales: nombre y apellido,
                dirección física y número de teléfono.
              </li>
              <li>
                CTT Express como encargado del tratamiento se obliga a:
                <ul class="list-style-none body-2 justify-text">
                  <li>
                    a) Utilizar los datos personales objeto de tratamiento, o los que recoja para su
                    inclusión, sólo para la finalidad objeto de este encargo. En ningún caso podrá
                    utilizar los datos para fines propios.
                  </li>
                  <li>
                    b) Tratar los datos de acuerdo con las instrucciones del responsable del
                    tratamiento.
                  </li>
                  <li>
                    c) Llevar, por escrito, un registro de todas las categorías de actividades de
                    tratamiento efectuadas por cuenta del responsable, que contenga:
                    <ul class="list-style-none body-2 justify-text">
                      <li class="pl-4">
                        - El nombre y los datos de contacto del encargado o encargados y de cada
                        responsable por cuenta del cual actúe el encargado y, en su caso, del
                        representante del responsable o del encargado y del delegado de protección
                        de datos.
                      </li>
                      <li class="pl-4">
                        - Las categorías de tratamientos efectuados por cuenta del responsable.
                      </li>
                      <li class="pl-4">
                        - Una descripción general de las medidas técnicas y organizativas de
                        seguridad apropiadas que esté aplicando.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 4" />
    </div>

    <!-- Página contrato 5 -->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <div class="fake-ol">
          <ul class="list-style-none body-2 justify-text">
            <li>
              d) No comunicar los datos a terceras personas, salvo que cuente con la
              autorización expresa del responsable del tratamiento, en los supuestos
              legalmente admisibles. Si el encargado quiere subcontratar tiene que informar al
              responsable y solicitar su autorización previa.
            </li>
            <li>
              e) Mantener el deber de secreto respecto a los datos de carácter personal a los
              que haya tenido acceso en virtud del presente encargo, incluso después de que
              finalice el contrato.
            </li>
            <li>
              f) Garantizar que las personas autorizadas para tratar datos personales se
              comprometan, de forma expresa y por escrito, a respetar la confidencialidad y a
              cumplir las medidas de seguridad correspondientes, de las que hay que
              informarles convenientemente.
            </li>
            <li>
              g) Mantener a disposición del responsable la documentación acreditativa del
              cumplimiento de la obligación establecida en el apartado anterior.
            </li>
            <li>
              h) Garantizar la formación necesaria en materia de protección de datos
              personales de las personas autorizadas para tratar datos personales.
            </li>
            <li>
              i) Cuando las personas afectadas ejerzan los derechos de acceso, rectificación,
              supresión y oposición, limitación del tratamiento y portabilidad de datos ante
              el encargado del tratamiento, éste debe comunicarlo por correo electrónico a la
              dirección que indique el responsable. La comunicación debe hacerse de forma
              inmediata y en ningún caso más allá del día laborable siguiente al de la
              recepción de la solicitud, juntamente, en su caso, con otras informaciones que
              puedan ser relevantes para resolver la solicitud.
            </li>
            <li>
              j) Notificación de violaciones de la seguridad de los datos. El encargado del
              tratamiento notificará al responsable del tratamiento, sin dilación indebida y a
              través de la dirección de correo electrónico que le indique el responsable, las
              violaciones de la seguridad de los datos personales a su cargo de las que tenga
              conocimiento, juntamente con toda la información relevante para la documentación
              y comunicación de la incidencia. Se facilitará, como mínimo, la información
              siguiente:
              <ul class="list-style-none body-2 justify-text">
                <li class="pl-4">
                  - Descripción de la naturaleza de la violación de la seguridad de los datos
                  personales, inclusive, cuando sea posible, las categorías y el número
                  aproximado de interesados afectados, y las categorías y el número aproximado
                  de registros de datos personales afectados.
                </li>
                <li class="pl-4">
                  - Datos de la persona de contacto para obtener más información.
                </li>
                <li class="pl-4">
                  - Descripción de las posibles consecuencias de la violación de la seguridad
                  de los datos personales. Descripción de las medidas adoptadas o propuestas
                  para poner remedio a la violación de la seguridad de los datos personales,
                  incluyendo, si procede, las medidas adoptadas para mitigar los posibles
                  efectos negativos.
                </li>
              </ul>
              Si no es posible facilitar la información simultáneamente, y en la medida en que
              no lo sea, la información se facilitará de manera gradual sin dilación indebida.
              <br />
              El ENCARGADO DEL TRATAMIENTO, a petición del responsable, comunicará en el menor
              tiempo posible las violaciones de la seguridad de los datos a los interesados,
              cuando sea probable que la violación suponga un alto riesgo para los derechos y
              las libertades de las personas físicas. <br />
              La comunicación debe realizarse en un lenguaje claro y sencillo y deberá,
              incluir los elementos que en cada caso señale el responsable, como mínimo:
              <ul class="list-style-none body-2 justify-text">
                <li class="pl-4">- La naturaleza de la violación de datos.</li>
                <li class="pl-4">
                  - Datos del punto de contacto del responsable o del encargado donde se pueda
                  obtener más información.
                </li>
                <li class="pl-4">
                  - Describir las posibles consecuencias de la violación de la seguridad de
                  los datos personales. Describir las medidas adoptadas o propuestas por el
                  responsable del tratamiento para poner remedio a la violación de la
                  seguridad de los datos personales, incluyendo, si procede, las medidas
                  adoptadas para mitigar los posibles efectos negativos.
                </li>
              </ul>
            </li>
            <li>
              k) Poner disposición del responsable toda la información necesaria para
              demostrar el cumplimiento de sus obligaciones, así como para la realización de
              las auditorías o las inspecciones que realicen el responsable u otro auditor
              autorizado por él.
            </li>
            <li>
              l) Implantar las medidas de seguridad técnicas y organizativas necesarias para
              garantizar la confidencialidad, integridad, disponibilidad y resiliencia
              permanentes de los sistemas y servicios de tratamiento
            </li>
            <li>m) Destino de los datos.</li>
            <li>
              n) Devolver al responsable del tratamiento los datos de carácter personal y, si
              procede, los soportes donde consten, una vez cumplida la prestación.
            </li>
            <li>
              o) La devolución debe comportar el borrado total de los datos existentes en los
              equipos informáticos utilizados por el encargado .
            </li>
            <li>
              p) No obstante, el encargado puede conservar una copia, con los datos
              debidamente bloqueados, mientras puedan derivarse responsabilidades de la
              ejecución de la prestación.
            </li>
          </ul>
        </div>
        <ol class="ninth-ol">
          <!-- punto 9 -->
          <li class="no-order body-2 justify-text">
            <ol class="seventh-ol">
              <li>
                El Cliente como Responsable del Tratamiento se obliga a:
                <ul class="list-style-none body-2 justify-text">
                  <li>
                    a) Entregar al encargado los datos necesarios para que pueda prestar el
                    servicio.
                  </li>
                  <li>
                    b) Velar, de forma previa y durante todo el tratamiento, por el cumplimiento del
                    RGPD por parte del encargado.
                  </li>
                  <li>c) Supervisar el tratamiento.</li>
                  <li>
                    d) El RESPONSABLE DEL TRATAMIENTO, manifiesta cumplir con todas las medidas
                    técnicas y organizativas necesarias para garantizar la seguridad de los datos
                    personales, centros de tratamiento, locales, equipos, sistemas, programas y las
                    personas que intervengan en el tratamiento de los datos de carácter personal
                    referidos.
                  </li>
                  <li>
                    e) El RESPONSABLE DEL TRATAMIENTO garantiza que la captación de los datos se
                    realiza de forma lícita, cumpliendo todos los requisitos exigidos legalmente
                    para la recogida y tratamiento de los datos de carácter personales.
                  </li>
                </ul>
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 5" />
    </div>
    <!-- Página contrato 6 -->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container">
        <div class="body-2 justify-text fake-ol">
          f) El RESPONSABLE DEL TRATAMIENTO se obliga a comunicar al cliente, cualquier
          variación que se produzca en los datos personales facilitados, a fin de mantener
          actualizados los datos tratados por el ENCARGADO DEL TRATAMIENTO
        </div>
        <ol class="ninth-ol">
          <!-- punto 9 -->
          <li class="no-order body-2 justify-text">
            <ol class="eighth-ol">
              <li class="body-2 justify-text">
                CTT EXPRESSO podrá subcontratar el servicio, sin necesidad de previa autorización
                del Cliente: (i) el nuevo encargado quedará sujeto a las mismas obligaciones que CTT
                EXPRESSO; (ii) En caso de incumplimiento por parte del subcontratado, CTT EXPRESSO
                continuará siendo responsable.
              </li>
              <li class="body-2 justify-text">
                EL RESPONSABLE DEL TRATAMIENTO contará con el nombramiento de un Delegado de
                Protección de datos con las siguientes funciones:
                <ul class="list-style-none body-2 justify-text">
                  <li>
                    a) Informar y asesorar al responsable o al encargado del tratamiento y a los
                    empleados que se ocupen del tratamiento de las obligaciones que les incumben en
                    virtud del presente Reglamento y de otras disposiciones de protección de datos
                    de la Unión Europea o de los Estados miembros;
                  </li>
                  <li>
                    b) supervisar el cumplimiento de lo dispuesto en el Reglamento, de otras
                    disposiciones de protección de datos de la Unión Europea o de los Estados
                    miembros y de las políticas del responsable o del encargado del tratamiento en
                    materia de protección de datos personales, incluida la asignación de
                    responsabilidades, la concienciación y formación del personal que participa en
                    las operaciones de tratamiento, y las auditorías correspondientes;
                  </li>
                  <li>
                    c) ofrecer el asesoramiento que se le solicite acerca de la evaluación de
                    impacto relativa a la protección de datos y supervisar su aplicación de
                    conformidad con el artículo 35 del Reglamento.
                  </li>
                  <li>d) cooperar con la autoridad de control;</li>
                  <li>
                    e) actuar como punto de contacto de la autoridad de control para cuestiones
                    relativas al tratamiento.
                  </li>
                </ul>
              </li>
              <li class="body-2 justify-text">
                Los datos personales de los firmantes y del resto de personas que puedan participar
                en la prestación de los servicios serán tratados de acuerdo a la normativa vigente.
              </li>
              <li class="body-2 justify-text">
                CTT EXPRESSO podrá remitir comunicaciones comerciales al Cliente por medios
                electrónicos, físicos o por vía telefónica, realizar encuestas de satisfacción para
                valorar el servicio prestado. No obstante lo anterior, el Cliente podrá oponerse a
                que se desarrollen las acciones comerciales y podrá manifestar su oposición a través
                de la dirección de correo electrónico: proteccióndedatos@cttexpress.com
              </li>
              <li class="body-2 justify-text">
                Los datos de carácter personal se mantendrán mientras se mantenga vigente el
                presente contrato y una vez resuelto el mismo, se conservarán para el supuesto de
                que no haya oposición al envío de comunicaciones comerciales.
              </li>
              <li class="body-2 justify-text">
                Los datos de carácter personal no se comunicarán a terceras ajenos. No se
                considerará comunicación a terceras personas cuando exista una solicitud por parte
                de la autoridad judicial, policial o administrativa o cuando sea necesaria para el
                correcto desarrollo de la relación contractual.
              </li>
              <li class="body-2 justify-text">
                Las partes podrán ejercer los derechos de acceso, rectificación y supresión de
                datos, manifestar su oposición al tratamiento de sus datos, así como revocar su
                consentimiento, enviando un correo a <u>proteccióndedatos@cttexpress.com</u>.
              </li>
            </ol>
          </li>
          <li class="body-2 justify-text" data-cy="complianceAndEthic">
            <b>Compliance y Ética: </b>
            <ol>
              <li class="body-2 justify-text">
                El Código de Conducta de CTT EXPRESSO y sus Subsidiarias es una norma vinculante para
                todos los administradores, directivos, empleados, colaboradores y restantes miembros
                de los grupos de interés de la compañía. El Cliente notificará cualquier infracción
                del Código de Conducta de CTT EXPRESSO y sus Subsidiarias o cualquier comportamiento
                inadecuado por parte de los administradores, directivos, empleados y colaboradores de
                CTT EXPRESSO, pudiendo utilizar a estos efectos el siguiente Canal Ético
                <u>https://canaletico.es/es/ctt</u>, estrictamente confidencial e incluso anónimo, colaborando
                en el desarrollo de cualquier actividad de investigación de las conductas objeto de
                denuncia.
              </li>
            </ol>
          </li>
          <li class="body-2 justify-text">
            <b>Notificaciones: </b>
            <ol>
              <li class="body-2 justify-text">
                Todas las notificaciones a las Partes en relación con este Contrato serán hechas en
                lengua española a las direcciones que constan en el encabezamiento del presente acuerdo.
                La modificación del domicilio de notificaciones por alguna de las Partes, no será eficaz
                hasta que se comunique fehacientemente a la otra.
              </li>
            </ol>
          </li>
          <li class="body-2 justify-text">
            <b>Legislación aplicable y jurisdicción:</b>
            <ol>
              <li class="body-2 justify-text">
                El presente contrato se regirá por lo dispuesto en el mismo, y subsidiariamente por
                lo establecido por la Ley 15/2009, de 11 de noviembre, del contrato de transporte
                terrestre de mercancía, la Ley deOrdenación de Transportes Terrestres(LOTT),su
                reglamento (ROTT) y normas de desarrollo, los Convenios Internacionales que sean de
                aplicación y supletoriamente por el Código de Comercio y demás legislación
                aplicable.
              </li>
              <li class="body-2 justify-text">
                Igualmente, ambas partes quedan sometidas a las condiciones generales que figuren en
                las Cartas de Porte o Albaranes de CTT EXPRESSO, físicos o telemáticos, y a las
                condiciones particulares acordadas para cada servicio realizado.
              </li>
              <li class="body-2 justify-text">
                Las partes pactan que queda excluido expresamente el sometimiento tanto al arbitraje de las Juntas
                Arbitrales de Transporte como a las de Consumo, con independencia de la cuantía de la controversia.
              </li>
              <li class="body-2 justify-text">
                Las partes, con renuncia expresa a su propio fuero se someten libremente a los
                Juzgados y Tribunales de la ciudad de {{ getLegalCity() }}
                en que se firma el presente Acuerdo para la resolución de los conflictos que
                pudieran derivarse de su ejecución o interpretación.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer :page="previousPages + 6" />
    </div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/signature-header.png')" class="page__header" />
      <div class="page__container body-2">
        En prueba de conformidad con cuanto antecede, firman las partes el presente contrato, a
        los efectos oportunos, en el lugar y fecha señalados
        <table class="full-width mt-2">
          <tr>
            <td>
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">CTT Express</p>
              </div>
              <div class="pl-12">
                <div class="d-flex justify-center">
                  <img :src="require('@/assets/firma.png')" class="mr-12 director-signature" />
                </div>

                <p class="body-1 mb-0 text-left">
                  {{ $t('PAGE2_DIRECTOR_NAME') }}
                </p>
                <p class="body-2 mb-12 text-left">
                  {{ $t('PAGE2_DIRECTOR_JOB') }}
                </p>
              </div>
            </td>
            <td class="pr-12">
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">El cliente</p>
              </div>
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">Firma, Sello y Fecha</p>
              </div>
              <div class="d-flex align-center pl-12 director-signature">
                <p class="body-2 mb-0">
                  <span class="white-font">SuFirma</span>
                </p>
              </div>

              <p class="body-2 mb-0 text-left">
                Nombre y Apellidos:
                <span class="white-font euro-symbol">NombreYApellidos</span>
              </p>
              <p class="body-2 mb-12 text-left">
                Cargo de la empresa, NIF:<span class="white-font">SuDNINIF</span>
              </p>
            </td>
          </tr>
        </table>
      </div>
      <Footer :page="previousPages + 7" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2024/Footer'

export default {
  name: 'ContractText',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
      optyServicePoints: [],
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    numberOfServicePoints() {
      const number = this.optyServicePoints.length

      return number
    },
    fullServPointsIntermediatePages() {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8
      return Math.floor(
        (this.numberOfServicePoints - maxNumberOfServicesIn1stPage) / maxNumberOfServicesPerPage,
      )
    },
    servPointsLeft() {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8

      return (
        (this.numberOfServicePoints - maxNumberOfServicesIn1stPage) % maxNumberOfServicesPerPage
      )
    },
    servicesAgreementPages() {
      const maxNumberOfServicesIn1stPage = 8
      const maxNumberOfServicesForLastPage = 4
      const maxNumberOfServicesFor2PagesTotal =
        maxNumberOfServicesIn1stPage + maxNumberOfServicesForLastPage

      let pages = 1
      if (
        this.numberOfServicePoints > 1 &&
        this.numberOfServicePoints <= maxNumberOfServicesFor2PagesTotal
      ) {
        pages = 2
      } else {
        pages =
          2 +
          this.fullServPointsIntermediatePages +
          (this.servPointsLeft > maxNumberOfServicesForLastPage ? 1 : 0)
      }
      return pages
    },
  },
  methods: {
    getServicePoints() {
      const unorderedServicePoints = this[GET_OFFER_ITEM]('optyServicePoints')
      const orderedByCompromisedShipmentsServicePoints = unorderedServicePoints.sort((a, b) =>
        a.compromisedShipments < b.compromisedShipments ? 1 : -1,
      )
      return orderedByCompromisedShipmentsServicePoints
    },
    getLegalCity() {
      const legalCity = this[GET_OFFER_ITEM]('legalCity');

      if (legalCity && legalCity != "")
        return legalCity;

      return "Madrid / Barcelona / Sevilla / San Sebastián"
    }
  },
  created() {
    this.optyServicePoints = this.getServicePoints()
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('ContractText')
  },
}
</script>
